import React from 'react';
import { cx } from './_cx';

/**
 * Badge (UI primitive)
 *
 * Small status/metadata label.
 */
export function Badge({ as, className, ...props }) {
  const Component = as || 'span';
  return <Component className={cx('pv-badge', className)} {...props} />;
}

